/**
 * Widerrufsverzicht – Checkout Gate
 * Extracted from snippet for testability.
 * Do NOT auto-init when running under test runner.
 */

export function isChecked() {
  return !!document.querySelector('.widerrufsverzicht-checkbox:checked');
}

export function syncCheckoutButtons() {
  var checked = isChecked();
  document.querySelectorAll('[name="checkout"]').forEach(function (btn) {
    btn.disabled = !checked;
    btn.style.opacity = checked ? '' : '0.5';
    btn.style.cursor  = checked ? '' : 'not-allowed';
  });
  if (checked) {
    document.querySelectorAll('.widerrufsverzicht-error').forEach(function (el) {
      el.style.display = 'none';
    });
  }
}

export function initWiderrufsverzicht() {
  // 1. Restore state from cart attributes
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      if (cart.attributes && cart.attributes['widerrufsverzicht_akzeptiert'] === 'yes') {
        document.querySelectorAll('.widerrufsverzicht-checkbox').forEach(function (cb) {
          cb.checked = true;
        });
      }
      syncCheckoutButtons();
    })
    .catch(function () {
      syncCheckoutButtons();
    });

  // 2. Checkbox change via event delegation
  document.addEventListener('change', function (e) {
    if (!e.target.matches('.widerrufsverzicht-checkbox')) return;
    var checked = e.target.checked;

    document.querySelectorAll('.widerrufsverzicht-checkbox').forEach(function (cb) {
      cb.checked = checked;
    });

    syncCheckoutButtons();

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: { widerrufsverzicht_akzeptiert: checked ? 'yes' : 'no' }
      })
    }).catch(function () {
      document.querySelectorAll('.widerrufsverzicht-checkbox').forEach(function (cb) {
        cb.checked = !checked;
      });
      syncCheckoutButtons();
    });
  });

  // 3. Safety-net click handler
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[name="checkout"]');
    if (!btn) return;
    if (!isChecked()) {
      e.preventDefault();
      document.querySelectorAll('.widerrufsverzicht-error').forEach(function (el) {
        el.style.display = 'block';
      });
      var firstCheckbox = document.querySelector('.widerrufsverzicht-checkbox');
      if (firstCheckbox && firstCheckbox.scrollIntoView) {
        firstCheckbox.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  });

  // 4. MutationObserver: re-sync when footer DOM changes
  var footerEl = document.getElementById('main-cart-footer');
  if (footerEl && typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function () {
      syncCheckoutButtons();
    });
    observer.observe(footerEl, { childList: true, subtree: true });
  }
}

// Auto-boot only in real browser, not test runner
if (typeof window !== 'undefined' && typeof process === 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWiderrufsverzicht);
  } else {
    initWiderrufsverzicht();
  }
}
